class ConvertPoints extends HTMLElement {
  constructor() {
    super()

    this.numbertoConvert = this.dataset.numberToConvert
    this.exchange = window.Shopify.currency.rate
    this.placement = this.querySelector('span')
    this.initialiseConvertPoints()
  }

  initialiseConvertPoints() {

    const localePoints = this.numbertoConvert / this.exchange
    const localePointsRounded = Math.floor(localePoints)
    this.placement.textContent = `${localePointsRounded} `
  }

}

customElements.define('convert-points', ConvertPoints)